function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOli({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 492 492",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,6.05833,-0.477085)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.899,39.543C93.899,44.34 90.008,48.228 85.214,48.228C80.418,48.228 76.529,44.34 76.529,39.543C76.529,34.748 80.418,30.857 85.214,30.857C90.008,30.857 93.899,34.748 93.899,39.543Z",
    style: {
      fill: "rgb(147,149,152)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.121,64.169L54.975,64.169C52.842,64.169 51.114,62.436 51.114,60.306L51.114,4.091C51.114,1.956 52.842,0.229 54.975,0.229L60.121,0.229C62.253,0.229 63.981,1.956 63.981,4.091L63.981,60.306C63.981,62.436 62.253,64.169 60.121,64.169Z",
    style: {
      fill: "rgb(140,198,63)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.689,94.285C49.935,94.285 42.36,91.587 36.364,86.686C35.568,86.04 35.066,85.103 34.962,84.085C34.858,83.066 35.165,82.051 35.813,81.255L39.071,77.272C40.42,75.62 42.849,75.378 44.501,76.725C48.209,79.75 52.89,81.417 57.689,81.417C69.189,81.417 78.548,72.062 78.548,60.556C78.548,58.427 80.276,56.698 82.409,56.698L87.554,56.698C89.687,56.698 91.415,58.427 91.415,60.556C91.415,79.157 76.287,94.285 57.689,94.285Z",
    style: {
      fill: "rgb(140,198,63)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.547,118C25.816,118 0,92.184 0,60.452C0,38.112 13.24,17.581 33.731,8.146C34.924,7.592 36.073,7.093 37.319,7.509C38.819,8.009 39.201,8.915 39.201,10.233L39.201,17.351C39.201,18.787 38.402,20.104 37.127,20.769C22.384,28.454 12.861,44.028 12.861,60.452C12.861,85.096 32.908,105.139 57.547,105.139C82.184,105.139 102.231,85.096 102.231,60.452C102.231,58.323 103.957,56.597 106.089,56.597L111.232,56.597C113.364,56.597 115.092,58.323 115.092,60.452C115.092,92.184 89.275,118 57.547,118Z",
    style: {
      fill: "rgb(140,198,63)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOli);
export default __webpack_public_path__ + "static/media/logoOli.017d248b.svg";
export { ForwardRef as ReactComponent };